<div class="container">
    <div class="row product-row">
        <div class="col-lg col-12 product-col">
            <div class="product-box">
                <div class="row">
                    <div class="col-md-5">
                        <h4>{{"view_time"|translate}}</h4>
                        <app-single-date-inlinePicker class="w-full" style="max-width: 350px;" [product]="product" [date]="form.get('date')"></app-single-date-inlinePicker>
                    </div>
                    <div class="col">
                        <h4 *ngIf="this.form.get('date').value && timeslots?.length > 0">{{"select_time"|translate}}</h4>
                        <div class="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-5 gap-3">
                            <div class="timeslot flex flex-col text-center" *ngFor="let timeslot of timeslots" (click)="addRemoveTimeslot(timeslot)" [ngClass]="{selected: isSelected(timeslot), second: true, third: false}">
                                <small class="font-weight-bold">{{ timeslot.start | date: "shortTime" }}</small>
                                <small class="font-weight-bold">{{ timeslot.end | date: "shortTime" }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-auto col-12 vendor-col">
            <div class="vendor-box" *ngIf="form.get('timeslots')?.value?.length > 0">
                <h4 class="text-center">{{"chosen_timeslots"|translate}}</h4>
                <div class="list">
                    <div *ngFor="let timeslot of form.get('timeslots').value; let i = index" class="pt-2">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="timeslot-list-item">
                            <small class="px-3">
                                <div class="font-weight-bold">{{ 'from' | translate }}: {{ timeslot.start | date: "short" }}</div>
                                <div class="font-weight-bold">{{ 'to' | translate }}: {{ timeslot.end | date: "short" }}</div>
                            </small>
                            <button type="button" mat-icon-button (click)="removeTimeslot(i)"><mat-icon>close</mat-icon></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
